import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import ProductCoChart from '../../../../components/productCoChart';

const config = {
  productComparisonChart: {
    columns: [
      {
        Header: 'Benefits',
        headerCellClassName: 'nmx-assistive-text',
        accessor: 'benefits',
      },
      {
        Header: 'Whole',
        accessor: 'whole',
      },
      {
        Header: 'Term',
        accessor: 'term',
      },
    ],
    data: [
      {
        benefits: (<>Guaranteed payout to loved ones<sup>1</sup></>),
        whole: 'true',
        term: 'true',
      },
      {
        benefits: (<>Lifelong protection<sup>1</sup></>),
        whole: 'true',
        term: false,
      },
      {
        benefits: (<>Accumulates cash value<sup>2</sup></>),
        whole: 'true',
        term: false,
      },
      {
        benefits: (<>Chance to get dividends<sup>3</sup></>),
        whole: 'true',
        term: false,
      },
      {
        benefits: (<>Premiums that never increase<sup>5</sup></>),
        whole: 'true',
        term: false,
      },
      {
        benefits: (<>Optional riders available</>),
        whole: 'true',
        term: 'true',
      },
    ],
    hideSectionHeading: false,
    sectionHeading: <>Which type of life insurance is best for you&#63; <WidowBlock>Compare them.</WidowBlock></>,
  },
};

export default () => (
  <SectionContainer
    id='whole-life-insurance-comparison-chart'
    themeType='lightTheme'
    backgroundVariant='lightC'
    moduleName='product-comparison-chart-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <ProductCoChart
          id='whole-life-insurance-comparison-chart'
          data-app-name='systolic-diastolic-product-comparison-chart'
          data-static-config={config}
        />
      </Col>
    </Row>
  </SectionContainer>
);
